var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-btn-dialog",
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          "btn-text": "Affectation",
          width: "70vw",
          color: "primary",
          icon: "search",
          disabled: _vm.disabled,
          title: "Recherche"
        },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function({ click }) {
              return [
                _c(
                  "v-select",
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        loading: _vm.loading,
                        items: _vm.items,
                        multiple: _vm.multiple,
                        "item-value": "id",
                        "append-icon": "mdi-plus",
                        color: "success",
                        readonly: "",
                        outlined: "",
                        dense: ""
                      },
                      on: {
                        input: _vm.handleInputChange,
                        "click:append": click
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function({ selected, item }) {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: { value: selected, close: "" },
                                    on: {
                                      "click:close": function($event) {
                                        return _vm.handleInputRemove(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm._f("displayTechName")(item)
                                        ) +
                                        "\n        "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-select",
                    _vm.$attrs,
                    false
                  )
                )
              ]
            }
          },
          {
            key: "actions",
            fn: function() {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-2",
                    attrs: { small: "" },
                    on: { click: _vm.cancel }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.generateMessage("tech_search.cancel")) +
                        "\n    "
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c("custom-technician-selector-table", {
                  attrs: {
                    "entity-id": _vm.entityId,
                    "property-id": _vm.propertyId,
                    "module-path": "actions/technicians",
                    selection: true
                  },
                  on: { input: _vm.handleAssignClick }
                })
              ]
            },
            proxy: true
          }
        ])
      },
      "custom-btn-dialog",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }